import { executeRequest, JFSRequest } from '@jfs/network'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (data: any) => {
  if (data?.data?.response) {
    return data?.data
  } else {
    throw data
  }
}

const createUserWithPermissions = (
  mobileNumber: string,
  firstName: string,
  lastName: string,
  email: string,
  entityId: string,
  userType: string,
  permissions: any[],
  tokens: any,
) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.grantPermissions),
    method: 'POST',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      mobile: { countryCode: '91', number: mobileNumber },
      name: { firstName: firstName, lastName: lastName },
      entityId: entityId,
      userType: userType,
      entityType: 1,
      email,
      permissions: JSON.parse(permissions),
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { createUserWithPermissions }
